module.exports = __webpack_public_path__ + "src/assets/img/selector-stub-sultan.cb0e4e5e.svg";